/** TanStack route for a Pre Flight – Scripts review detail page. */
export const SCRIPT_REVIEW_ROUTE = "/pre-flight-scripts/review/$reviewId" as const;

/**
 * @deprecated Partners now use SCRIPT_REVIEW_ROUTE (Pre Flight – Scripts). Kept for
 * backwards-compatible redirects from old bookmarks.
 */
export const MARKETPLACE_PARTNER_SCRIPT_REVIEW_ROUTE =
  "/marketplace/partner/reviews/$reviewId" as const;

/** @deprecated Use SCRIPT_REVIEW_ROUTE. */
export const PREFLIGHT_REPORT_ROUTE = SCRIPT_REVIEW_ROUTE;

/** @deprecated Use SCRIPT_REVIEW_ROUTE. */
export const MARKETPLACE_PARTNER_PREFLIGHT_REPORT_ROUTE = MARKETPLACE_PARTNER_SCRIPT_REVIEW_ROUTE;

/** Absolute in-app path for mailto links and external sharing. */
export function scriptReviewPath(reviewId: string, _audience: "client" | "partner" = "client"): string {
  return `/pre-flight-scripts/review/${reviewId}`;
}

/** @deprecated Use scriptReviewPath. */
export function preflightReportPath(reportId: string): string {
  return `/pre-flight-scripts/review/${reportId}`;
}

export function scriptReviewUrl(reviewId: string, audience: "client" | "partner" = "client"): string {
  const path = scriptReviewPath(reviewId, audience);
  if (typeof window === "undefined") {
    return path;
  }
  return `${window.location.origin}${path}`;
}

/** @deprecated Use scriptReviewUrl. */
export function preflightReportUrl(reportId: string, audience: "client" | "partner" = "client"): string {
  return scriptReviewUrl(reportId, audience);
}

export function buildScriptReviewShareMailto(input: {
  reviewId: string;
  scriptTitle: string;
  clientName: string;
  audience?: "client" | "partner";
}): string {
  const url = scriptReviewUrl(input.reviewId, input.audience ?? "client");
  const subject = encodeURIComponent(`Script review: ${input.scriptTitle}`);
  const body = encodeURIComponent(
    `Pre Flight – Scripts review for ${input.scriptTitle} (${input.clientName}):\n\n${url}`,
  );
  return `mailto:?subject=${subject}&body=${body}`;
}

/** @deprecated Use buildScriptReviewShareMailto. */
export function buildPreflightShareMailto(input: {
  reportId: string;
  scriptTitle: string;
  clientName: string;
  audience?: "client" | "partner";
}): string {
  return buildScriptReviewShareMailto({
    reviewId: input.reportId,
    scriptTitle: input.scriptTitle,
    clientName: input.clientName,
    audience: input.audience,
  });
}
